import { getValidAuthorizationHeader } from '../auth/cognito';
import { getReferralsApiUrl } from '../config/api';
export async function fetchSignInUserInfo() {
    const authorization = await getValidAuthorizationHeader();
    const response = await fetch(getReferralsApiUrl('/temp/signin-user-info'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: authorization,
        },
        body: JSON.stringify({}),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`signinUserInfo failed (${response.status}): ${text.slice(0, 200)}`);
    }
    return (await response.json());
}
let signInUserInfoPromise = null;
/** Memoized signinUserInfo fetch so multiple callers share one request per session. */
export function ensureSignInUserInfo() {
    if (!signInUserInfoPromise) {
        signInUserInfoPromise = fetchSignInUserInfo().catch((err) => {
            signInUserInfoPromise = null;
            throw err;
        });
    }
    return signInUserInfoPromise;
}
export function clearSignInUserInfoCache() {
    signInUserInfoPromise = null;
}
